import React from "react";
import { Column } from "../Table/types";
import SkeletonText from "./SkeletonText";

interface PropsWithColumns {
  columnCount?: number;
  columns: Column[];
  rowCount: number;
}

interface PropsWithColumnCount {
  columnCount: number;
  columns?: Column[];
  rowCount: number;
}

type Col = {
  align: string;
  width?: number;
};

type Props = PropsWithColumns | PropsWithColumnCount;

const SkeletonTableBody: React.FC<Props> = ({ columns, columnCount = 1, rowCount }) => {
  const cols: Col[] = columns ? columns : Array.from({ length: columnCount }, () => ({ align: "left", width: 200 }));
  const rows = Array.from({ length: rowCount }, (_, i) => i);

  return (
    <tbody>
      {rows.map((rowIndex) => (
        <tr key={rowIndex}>
          {cols.map((column, colIndex) => (
            <td key={colIndex} className="sm:text-left">
              <SkeletonText align={column.align} />
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  );
};

export default SkeletonTableBody;
